import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";

import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import LoaderSpinner from "context/LoaderSpinner";
import ButtonsActions from "views/utils/buttonsActions";
import TableOrders from "./Orders/TableOrders";
import PrevOrders from "./Orders/PrevOrders";
import FormOrders from "./Orders/FormOrders";
import FilterModel from "components/FilterModel";
import ItemsModel from "core/itemsModel";
import navs from "./navs";
import axiApi from "ApiCaller";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import useCustomTranslation from "core/customTranslation";
import OrderingModel from "components/ordering/OrderingModel";

const OrdersModel = {};

const ChoicesStatus = {
    P: "Pending",
    I: "In Progress",
    C: "Completed",
    X: "Cancelled",
}

const ChoicesOrigin = {
    m: "Manual",
    p: "Periodic",
    a: "Alert",
}


const ViewOrders = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useCustomTranslation("common");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    const bread = [
        {name: _Tr("labels.maintenance"), url: "/maintenance/", current: false},
        {name: _Tr("labels.orders"), current: true},
    ];
    document.title = _Tr("labels.orders");

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    const [itemsShow, setItemsShow] = useState([]);
    const [item, setItem] = useState({...OrdersModel});
    const [leaderOptions, setLeaderOptions] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const headersTable = [
        {name: _Tt("tasks.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("programming.name") , attr: 1, direction: "asc", active: false},
        {name: _Tt("common.start") , attr: 2, direction: "asc", active: false},
        {name: _Tt("common.status"), attr: 3, direction: "asc", active: false},
        {name: _Tt("common.origin"), attr: 4, direction: "asc", active: false},
        {name: _Tt("common.created_by") , attr: 5, direction: "asc", active: false},
        {name: _Tt("common.destination_email") , attr: 6, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.add.active = true;
        buttons.add.onClick = onClickAdd;
        buttons.add.disabled = false;
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchTasks();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchTasks();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = OrdersModel;
        fetchGetTasks();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchTasks();
    };

    const fetchGetTasks = () => {
        setIsLoading(true);
        axiApi
            .get("/api/maint/orders/")
            .then((resp) => {
                if (resp.data) {
                    console.log(resp.data);
                    items.current.showed = [...resp.data.items];
                    setItemsShow([...resp.data.items]);
                    if (resp.data.leaders) {
                       setLeaderOptions(
                            resp.data.leaders.map((email) => ({ value: email, label: email }))
                        );
                    }
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchTasks = () => {
        setIsLoading(true);
        axiApi
            .post("/api/maint/orders/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickAdd = () => {
        setItem({...OrdersModel});
        setShowForm(true);
    };

    const onClickEdit = () => {
        let selectedItem = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        if (!selectedItem) return;
        const it = {...selectedItem};
        const _norm = (s) => (s ? s.replace('Z', '').slice(0,16) : s);
        it.scheduled_at = _norm(it.scheduled_at);
        it.started_at = _norm(it.started_at);
        setItem(it);

        const curLeader = it.order_leader_email || null;
        if (curLeader) {
            setLeaderOptions((prev) => {
                if (prev && prev.some((o) => o.value === curLeader)) return prev;
                return [...(prev || []), {value: curLeader, label: curLeader}];
            });
        }

        setShowForm(true);
    };

    const onClickDelete = () => {
        AlertQuestion.fire(_Tc("alert.delete.title"), `${items.current.checkBoxes.length} ${_Tc("alert.delete.selected")}`).then((r) => {
            setIsLoading(true);
            if (r.isConfirmed) {
                let ids = items.current.getChosenIds();
                setItem({...OrdersModel});

                    axiApi
                    .post("/api/maint/orders/delete/", {items: ids})
                    .then((r) => {
                        if (r.data.status) {
                            Alert.success(_Tc("alert.delete.success"), _Tc("alert.delete.disp"));
                            items.current.showed = items.current.showed.filter((_item) => !ids.includes(_item.id));
                            items.current.all = items.current.all.filter((_item) => !ids.includes(_item.id));
                            items.current.checkBoxes = [];
                            setItemsShow([...items.current.showed]);
                        } else {
                            r.data.message && console.info(r.data.message);
                            Alert.warning(_Tc("alert.notify.admin"), _Tc("alert.delete.error"));
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        Alert.error(_Tc("alert.notify.admin"), _Tc("alert.delete.error"));
                    })
                    .finally(() => {
                        const buttons = {...buttonsTB};
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        items.current.clearChosen();
                        setButtonsTB(buttons);
                        setIsLoading(false);
                        setShowPrev(false);
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />

            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableOrders
                            items={items}
                            itemsShow={itemsShow}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                            orderingRef={orderingRef}
                            ChoicesStatus={ChoicesStatus}
                            ChoicesOrigin={ChoicesOrigin}
                        />
                    </LoaderSpinner>
                </div>
                {showPrev ? (
                    <div className="col-md col-12 prev-item" style={{maxWidth: "300px"}}>
                        <PrevOrders item={item} showPreview={showPrev} ChoicesStatus={ChoicesStatus} ChoicesOrigin={ChoicesOrigin} />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {showForm ? (
                <FormOrders
                    item={item}
                    setItem={setItem}
                    setShowCanvas={setShowForm}
                    showCanvas={showForm}
                    fetchTasks={fetchTasks}
                    leaderOptions={leaderOptions}
                    ChoicesStatus={ChoicesStatus}
                    ChoicesOrigin={ChoicesOrigin}
                />
            ) : (
                <></>
            )}
        </>
    );
};

export default ViewOrders;
